export default __webpack_public_path__ + "static/media/grafema_clivitalbio_02.f0666c1a.jpg";